import FLSApiClient from '../common/FLSApiClient';
//base on UpdateProfile
export const GeneratePassForGooglePay = (sessionId: string): Promise<any> => {
  return FLSApiClient.get('/api/GooglePay/GooglePayPass', {
    params: {
      sessionId: sessionId,
    },
  });
};

export const GeneratePassForApplePass = (sessionId: string): Promise<any> => {
  return FLSApiClient.post('/v1/pass/' + sessionId);
};
